import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import SmoothScroll from "@/components/SmoothScroll";
import { ContactDialogProvider } from "@/components/ContactDialogs";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Aszf from "@/pages/Aszf";
import Admin from "@/pages/Admin";
import Login from "@/pages/Login";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function Chrome({ children }) {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      {!isAdmin && <Navbar />}
      <main>{children}</main>
      {!isAdmin && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <SmoothScroll>
            <ContactDialogProvider>
              <ScrollToTop />
              <Chrome>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/bemutatkozas" element={<About />} />
                  <Route path="/aszf" element={<Aszf />} />
                  <Route path="/admin/login" element={<Login />} />
                  <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
                </Routes>
              </Chrome>
              <Toaster position="bottom-right" />
            </ContactDialogProvider>
          </SmoothScroll>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
